

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { OncallCycle, OncallCycleText, WeekDays, DutyModes, DutyModeMap, DEFAULT_AVATAR } from '@/config/map.conf';
import * as validators from '@/utils/validator';
import * as api from '@/api';
// 拖拽排序插件
import { Container, Draggable } from 'vue-smooth-dnd';
import { applyDrag } from '@/utils/helpers';

import { Form } from '@ss/mtd-vue';

const sanitizeDutyMode = (mode: string) => {
    if (['SINGLE_TURN', 'MULTI_ONLINE'].indexOf(mode) > -1) {
        return mode;
    }
    // 默认是多人在线的
    return 'MULTI_ONLINE';
};

/**
 * 设置轮值规则
 *
 * @author liyuyao
 * @date 04/12/2019
 */
@Component({
    components: {
        Container,
        Draggable
    }
})
export default class SetOncallRule extends Vue {
    @Prop({ default: '' })
    ruleCycle: string;
    @Prop({ default: '' })
    ruleStart: string;
    @Prop({ default: '' })
    duty: string;

    singleFormCustom: any = {
        ruleCycle: 'day',
        ruleStart: ''
    };
    ruleCustom: any = {
        ruleCycle: [{ validator: validators.validateOncallCycle, trigger: 'change' }],
        ruleStart: [{ validator: validators.validateOncallStart, trigger: 'change' }]
    };
    visible: Boolean = true;
    btnLoading: Boolean = false;

    dutyMode: string = 'MULTI_ONLINE';

    oncallCycle: string[] = OncallCycle;
    oncallCycleText: any = OncallCycleText;
    dutyModes: any = DutyModes;
    weekDays: string[] = WeekDays;
    rgOncallList: any = [];

    multiUsers: any = [];

    defaultAvatar: string = DEFAULT_AVATAR;

    mounted() {
        this.getRgOncallList();
        this.singleFormCustom.ruleCycle = this.ruleCycle === 'nothing' ? '' : this.ruleCycle;
        this.singleFormCustom.ruleStart = this.ruleStart === 'nothing' ? '' : this.ruleStart;
        this.dutyMode = sanitizeDutyMode(this.duty);
    }
    handleClose() {
        this.$emit('close');
    }
    submit() {
        // HACK: 依赖 this.$parent 获取当前生效的值班模式
        const currentMode = (this.$parent as any).dutyMode;

        // 如果当前没有生效的模式，或者没有变更模式，就直接跳过
        if (!currentMode || currentMode === this.dutyMode) {
            this.isMultiDuty ? this.multiSubmit() : this.singleSubmit();
            return;
        }

        const currentModeText = DutyModeMap[currentMode];
        const switchTo = DutyModeMap[this.dutyMode];
        this.$mtd
            .confirm({
                title: '切换值班模式',
                message: `当前值班模式为 <strong>${currentModeText}</strong>，是否切换为 <strong>${switchTo}</strong>？`,
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                okButtonProps: { type: 'danger' },
                onOk: async () => {
                    this.isMultiDuty ? this.multiSubmit() : this.singleSubmit();
                }
            })
            .catch(e => e);
    }
    singleSubmit() {
        const singleFormCustom = this.$refs.singleFormCustom as Form;
        singleFormCustom
            .validate(async valid => {
                if (valid) {
                    this.setSortAndSetting();
                }
            })
            .catch(e => e);
    }
    async multiSubmit() {
        const res = await api.rgApi.multiModeSetting({
            rgId: this.rgId,
            mode: 'MULTI_ONLINE',
            users: this.paramsMultiUsers
        });
        if (res.code === 200) {
            this.handleSuccess();
        }
    }
    async setSortAndSetting() {
        this.btnLoading = true;
        try {
            const oncallSuccess = await this.postOncallRule();
            if (oncallSuccess) {
                const sortSuccess = await this.postOncallSort();
                if (sortSuccess) {
                    this.handleSuccess();
                }
            }
        } catch (error) {
            console.error('Error in setSortAndSetting:', error);
        } finally {
            this.btnLoading = false; // 确保按钮加载状态在所有情况下都能被重置
        }
    }
    async postOncallSort() {
        const users = this.rgOncallList.map(item => {
            return item.identify;
        });
        let success = false;
        const res = await api.rgApi.oncallSort({
            rgId: this.rgId,
            users: users,
            ruleCycle: this.singleFormCustom.ruleCycle
        });
        if (res.code === 200) {
            success = true;
        }
        return success;
    }
    async postOncallRule() {
        const ruleStart = this.handleCycleResult();
        const res = await api.rgApi.singleModeSetting({
            mode: 'SINGLE_TURN',
            rule: {
                rgId: this.rgId,
                ruleCycle: this.singleFormCustom.ruleCycle,
                ruleStart: ruleStart
            }
        });
        if (res.code === 200) {
            this.$emit('sort-success');
        }
        return res && res.code === 200;
    }
    handleSuccess() {
        this.$mtd.message({
            message: '值班设置成功',
            type: 'success'
        });
        this.$emit('rule-success');
        this.handleClose();
    }
    cycleChange() {
        this.singleFormCustom.ruleStart = null;
    }
    onDropEvent(dropResult) {
        this.rgOncallList = applyDrag(this.rgOncallList, dropResult);
    }
    handleCycleResult() {
        let cycle = '';
        if (this.singleFormCustom.ruleCycle === 'day' || this.singleFormCustom.ruleCycle === 'day_skip') {
            cycle = '0-' + (this.singleFormCustom.ruleStart - 1);
        }
        if (this.singleFormCustom.ruleCycle === 'week') {
            cycle = this.singleFormCustom.ruleStart + '-0';
        }
        return cycle;
    }
    async getRgOncallList() {
        try {
            const res = await api.rgApi.getOncallUserList({ rgId: this.rgId });
            this.rgOncallList = res.data.items;
            this.multiUsers = this.rgOncallList.filter(user => {
                return user.isOncall === true;
            });
            this.getUserAvatar();
        } catch (e) {
            console.log(e);
        }
    }
    async getUserAvatar() {
        const users = this.rgOncallList.map(user => {
            return user.identify;
        });
        const res = await api.ctiApi.searchDisplayNameList(users);
        const { code, data } = res;
        if (code === 200) {
            this.rgOncallList.forEach((user, index) => {
                this.$set(this.rgOncallList[index], 'avatar', (data[user.identify] && data[user.identify].avatar) || DEFAULT_AVATAR);
            });
        }
    }
    get timePoints() {
        let pointsList = [];
        if (this.singleFormCustom.ruleCycle === 'day' || this.singleFormCustom.ruleCycle === 'day_skip') {
            for (let i = 0; i < 24; i++) {
                pointsList[i] = `每天${i}点`;
            }
        }
        if (this.singleFormCustom.ruleCycle === 'week') {
            pointsList = this.weekDays.map(num => {
                return `每周${num}0点`;
            });
        }
        return pointsList;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    get isMultiDuty() {
        return this.dutyMode === 'MULTI_ONLINE';
    }
    get paramsMultiUsers() {
        return this.multiUsers.map(user => {
            return {
                onCallId: user.oncallId,
                misId: user.identify,
                userId: user.id
            };
        });
    }
}
